import type { Dict } from '../index.js';

/** Arabic: attendance. Keys are the exact English text. */
export const attendance: Dict = {
  "Daily overview": "النظرة اليومية",
  "Devices": "الأجهزة",
  "Import from machine": "استيراد من الجهاز",
  "Clock-ins from the fingerprint machine, the door QR code and the app, calculated against each person's schedule and time zone.": "تسجيلات الحضور من جهاز البصمة ورمز QR على الباب والتطبيق، محسوبة وفق جدول عمل كل شخص ومنطقته الزمنية.",
  "Working now": "يعملون الآن",
  "Late": "متأخر",
  "“Date” is each employee's own local date. Click a name to see their punches and correct them.": "«التاريخ» هو التاريخ المحلي لكل موظف. انقر على الاسم لعرض تسجيلاته وتصحيحها.",
  "Export everyone": "تصدير الجميع",
  "See every day with punches, worked hours, lateness and missing clock-outs.": "اعرض كل يوم مع التسجيلات وساعات العمل والتأخير وتسجيلات الانصراف الناقصة.",
  "Click a day to see its punches.": "انقر على يوم لعرض تسجيلاته.",
  "Corrections never delete anything: a wrong punch is voided (kept, crossed out) and a missing one is added — both with a reason in the audit log.": "التصحيحات لا تحذف شيئًا: يُلغى التسجيل الخاطئ (يبقى مشطوبًا) ويُضاف التسجيل الناقص — وكلاهما مع سبب في سجل التدقيق.",
  "Void punch": "إلغاء التسجيل",
  "The punch stays in the history (crossed out) and is no longer used in calculations.": "يبقى التسجيل في السجل (مشطوبًا) ولا يُستخدم بعد الآن في الحسابات.",
  "Add a punch": "إضافة تسجيل",
  "Add punch": "إضافة تسجيل",
  "Time is in the employee's time zone:": "الوقت حسب المنطقة الزمنية للموظف:",
  "Clock in": "تسجيل الحضور",
  "Clock out": "تسجيل الانصراف",
  "e.g. Forgot to clock out — confirmed by the office manager": "مثال: نسي تسجيل الانصراف — بتأكيد من مدير المكتب",
  "Open this link once on the door tablet. It is shown only now — if you lose it, issue a new key.": "افتح هذا الرابط مرة واحدة على جهاز الباب. يُعرض الآن فقط — إذا فقدته فأصدر مفتاحًا جديدًا.",
  "Pairing link": "رابط الربط",
  "Tip: add the page to the tablet's home screen and keep the screen on. Restrict it to the office network below so a photo of the code is useless elsewhere.": "نصيحة: أضف الصفحة إلى الشاشة الرئيسية للجهاز اللوحي وأبقِ الشاشة مضاءة. قيّدها بشبكة المكتب أدناه حتى لا تفيد صورة الرمز في أي مكان آخر.",
  "This key is shown only now. Store it in the integration's settings.": "يُعرض هذا المفتاح الآن فقط. احفظه في إعدادات التكامل.",
  "Device key": "مفتاح الجهاز",
  "Endpoint (POST, header Authorization: Bearer <key>)": "عنوان الاستقبال (POST، الترويسة Authorization: Bearer <key>)",
  "Live connection (ZKTeco and compatible “ADMS / Cloud server” machines)": "الاتصال المباشر (أجهزة ZKTeco والأجهزة المتوافقة مع «ADMS / Cloud server»)",
  "On the machine:": "على الجهاز:",
  "(name varies by model). Enter:": "(يختلف الاسم حسب الطراز). أدخل:",
  "Port:": "المنفذ:",
  "HTTPS on": "HTTPS مفعّل",
  "Serial number registered here:": "الرقم التسلسلي المسجَّل هنا:",
  "— add it in Edit": "— أضفه من «تعديل»",
  "If the machine cannot connect, export the attendance log to a USB stick and use “Import from machine”.": "إذا تعذّر اتصال الجهاز، فصدِّر سجل الحضور إلى ذاكرة USB واستخدم «استيراد من الجهاز».",
  "Add device": "إضافة جهاز",
  "No devices yet": "لا توجد أجهزة بعد",
  "Add the office fingerprint machine (live or by file import) and/or a door tablet showing a rotating QR code.": "أضف جهاز البصمة في المكتب (اتصال مباشر أو استيراد ملف) و/أو جهازًا لوحيًا على الباب يعرض رمز QR متغيّرًا.",
  "New pairing link": "رابط ربط جديد",
  "New key": "مفتاح جديد",
  "Model": "الطراز",
  "Serial number": "الرقم التسلسلي",
  "Punches recorded": "التسجيلات المسجَّلة",
  "Allowed networks": "الشبكات المسموح بها",
  "Any": "أي شبكة",
  "Set “Allowed networks” to the office's IP (or the office network, e.g. 192.168.1.0/24). Without it, anyone who knows this machine's serial number could send fake punches.": "اضبط «الشبكات المسموح بها» على عنوان IP الخاص بالمكتب (أو شبكة المكتب، مثل 192.168.1.0/24). من دون ذلك، يمكن لأي شخص يعرف الرقم التسلسلي لهذا الجهاز إرسال تسجيلات مزيفة.",
  "{name} — connection details": "{name} — بيانات الاتصال",
  "Issue a new key?": "إصدار مفتاح جديد؟",
  "The current key / pairing link stops working immediately. You will need to set up the device again with the new one.": "يتوقف المفتاح / رابط الربط الحالي عن العمل فورًا، وستحتاج إلى إعداد الجهاز مجددًا باستخدام الجديد.",
  "Issue new key": "إصدار مفتاح جديد",
  "Fingerprint machine": "جهاز البصمة",
  "Door QR kiosk": "جهاز الباب برمز QR",
  "Integration (API)": "تكامل (API)",
  "Door QR kiosk (tablet)": "جهاز الباب برمز QR (جهاز لوحي)",
  "Other integration (API)": "تكامل آخر (API)",
  "Cairo office door": "باب مكتب القاهرة",
  "Cairo office fingerprint": "بصمة مكتب القاهرة",
  "Brand": "العلامة التجارية",
  "e.g. ZKTeco": "مثال: ZKTeco",
  "Needed only for the live connection. Shown on the machine under System Info / Device Info.": "مطلوب للاتصال المباشر فقط. يظهر على الجهاز ضمن System Info / Device Info.",
  "Use the machine's In/Out buttons": "استخدام أزرار الدخول/الخروج في الجهاز",
  "Off (recommended): the system works out in/out from the order of punches, so people who press the wrong key don't break their day.": "إيقاف (موصى به): يحدّد النظام الدخول/الخروج من ترتيب التسجيلات، فلا يتأثر يوم من يضغط الزر الخطأ.",
  "Time zone of the device": "المنطقة الزمنية للجهاز",
  "Machines record local time without a zone; this is used to convert it.": "تسجّل الأجهزة الوقت المحلي دون منطقة زمنية؛ ويُستخدم هذا الإعداد لتحويله.",
  "Allowed networks (optional)": "الشبكات المسموح بها (اختياري)",
  "Office public IP, e.g. 41.33.10.20 — scans from other networks are refused. Leave empty to allow any.": "عنوان IP العام للمكتب، مثل 41.33.10.20 — تُرفض عمليات المسح من الشبكات الأخرى. اتركه فارغًا للسماح بأي شبكة.",
  "Strongly recommended: only accept this machine from the office IP or office network (e.g. 192.168.1.0/24).": "موصى به بشدة: اقبل هذا الجهاز فقط من عنوان IP الخاص بالمكتب أو شبكة المكتب (مثل 192.168.1.0/24).",
  "Disabled devices are refused.": "تُرفض الأجهزة المعطَّلة.",
  "Upload an attendance file": "رفع ملف حضور",
  "Export the log from the fingerprint machine (USB stick → {file}, or the CSV/TXT from its software) and upload it. Re-importing the same file is safe: punches already recorded are skipped.": "صدِّر السجل من جهاز البصمة (ذاكرة USB ← {file}، أو ملف CSV/TXT من برنامجه) ثم ارفعه. إعادة استيراد الملف نفسه آمنة: تُتجاوز التسجيلات المسجَّلة مسبقًا.",
  "Machine": "الجهاز",
  "Not specified": "غير محدد",
  "Time zone of the times in the file": "المنطقة الزمنية للأوقات في الملف",
  "File": "الملف",
  "attlog.dat, .txt or .csv — up to 10 MB. Employees are matched by their fingerprint machine ID (or employee ID).": "attlog.dat أو ‎.txt أو ‎.csv — حتى 10 ميغابايت. يُطابَق الموظفون حسب رقمهم في جهاز البصمة (أو الرقم الوظيفي).",
  "Check file": "فحص الملف",
  "Import 1 punch": "استيراد تسجيل واحد",
  "Import {n} punches": "استيراد {n} تسجيلات",
  "Imported 1 punch, {d} already recorded.": "تم استيراد تسجيل واحد، و{d} مسجَّلة مسبقًا.",
  "Imported {n} punches, {d} already recorded.": "تم استيراد {n} تسجيلات، و{d} مسجَّلة مسبقًا.",
  "Imported 1 punch.": "تم استيراد تسجيل واحد.",
  "Imported {n} punches.": "تم استيراد {n} تسجيلات.",
  "Recent imports": "آخر عمليات الاستيراد",
  "Live from machine": "مباشر من الجهاز",
  "{imported} new · {duplicates} duplicate · {rows} rows": "{imported} جديد · {duplicates} مكرر · {rows} صفوف",
  "unknown IDs: {ids}": "أرقام غير معروفة: {ids}",
  "Nothing imported yet.": "لم يُستورد شيء بعد.",
  "Check result — {format}": "نتيجة الفحص — {format}",
  "Rows": "الصفوف",
  "New punches": "تسجيلات جديدة",
  "Already recorded": "مسجَّلة مسبقًا",
  "Problems": "المشكلات",
  "1 punch is dated in a closed reporting period. They are kept in the log but don't change the frozen figures unless that period is reopened.": "تسجيل واحد يقع ضمن فترة مُقفلة. يُحفظ في السجل لكنه لا يغيّر الأرقام المجمَّدة إلا إذا أُعيد فتح تلك الفترة.",
  "{n} punches are dated in a closed reporting period. They are kept in the log but don't change the frozen figures unless that period is reopened.": "{n} تسجيلات تقع ضمن فترة مُقفلة. تُحفظ في السجل لكنها لا تغيّر الأرقام المجمَّدة إلا إذا أُعيد فتح تلك الفترة.",
  "These machine IDs don't match any employee and will be skipped: {ids}. Set the “Fingerprint machine ID” on the employee's profile, then check again.": "أرقام الجهاز هذه لا تطابق أي موظف وسيتم تجاوزها: {ids}. اضبط «رقم جهاز البصمة» في ملف الموظف، ثم افحص مجددًا.",
  "Line {line}: {message}": "السطر {line}: {message}",
  "…and {n} more": "…و{n} أخرى",
  "Machine ID": "رقم الجهاز",
  "Unknown": "غير معروف",
  "First {n} rows shown · times displayed in your chosen time display.": "تُعرض أول {n} صفوف · الأوقات معروضة حسب إعداد عرض الوقت الذي اخترته.",
  "in": "دخول",
  "out": "خروج",
  "punch": "تسجيل",
  "Missing clock-in": "تسجيل حضور ناقص",
  "Missing clock-out": "تسجيل انصراف ناقص",
  "Expected": "المطلوب",
  "Difference": "الفرق",
  "Days present": "أيام الحضور",
  "Left early": "انصراف مبكر",
  "Leave days": "أيام الإجازة",
  "{n} days": "{n} أيام",
  "{n} day": "{n} يوم",
  "No punches.": "لا توجد تسجيلات.",
  "In": "دخول",
  "Out": "خروج",
  "Added by {name}": "أضافه {name}",
  "Voided by {name}": "ألغاه {name}",
  "Voided": "ملغى",
  "Void": "إلغاء",
  "Early": "مبكر",
  "Hours from computer activity (desktop agent), not clock-in/out": "ساعات محسوبة من نشاط الكمبيوتر (برنامج سطح المكتب)، وليس من تسجيل الحضور/الانصراف",
  "computer": "كمبيوتر",
  "Add punch on {date}": "إضافة تسجيل في {date}",
  "Punch": "تسجيل",
  "Times in {zone}": "الأوقات بتوقيت {zone}",
  "first clock-in to last clock-out, minus break": "من أول تسجيل حضور إلى آخر تسجيل انصراف، مطروحًا منه الاستراحة",
  "sum of in/out intervals": "مجموع فترات الدخول/الخروج",
  "This period": "هذه الفترة",
  "Last period": "الفترة السابقة",
  "This week": "هذا الأسبوع",
  "Last week": "الأسبوع الماضي",
  "This month": "هذا الشهر",
  "Last month": "الشهر الماضي",
  "Custom…": "مخصص…",
  "Public holidays": "العطلات الرسمية",
  "Each employee is assigned one holiday calendar; its dates are excluded from leave calculations.": "يُخصَّص لكل موظف تقويم عطلات واحد، وتُستثنى تواريخه من حساب الإجازات.",
  "New calendar": "تقويم جديد",
  "No holiday calendars": "لا توجد تقاويم عطلات",
  "Create one per country (e.g. Lebanon, Saudi Arabia, UAE).": "أنشئ تقويمًا لكل دولة (مثل لبنان، السعودية، الإمارات).",
  "Calendars": "التقاويم",
  "{dates} dates · {employees} employees": "{dates} تواريخ · {employees} موظفين",
  "Add holiday": "إضافة عطلة",
  "No holidays in {year}": "لا توجد عطلات في {year}",
  "Half day": "نصف يوم",
  "Official": "رسمية",
  "Edit calendar": "تعديل التقويم",
  "New holiday calendar": "تقويم عطلات جديد",
  "e.g. Lebanon": "مثال: لبنان",
  "Not country-specific": "غير مرتبط بدولة",
  "Notes": "ملاحظات",
  "Official source": "المصدر الرسمي",
  "Linked calendars are kept in sync with the government's published list.": "تبقى التقاويم المرتبطة متزامنة مع القائمة التي تنشرها الحكومة.",
  "None — I enter holidays myself": "لا يوجد — أُدخل العطلات بنفسي",
  "Egyptian Presidency ({site})": "الرئاسة المصرية ({site})",
  "Official page address": "عنوان الصفحة الرسمية",
  "Leave empty to use the official English holidays page.": "اتركه فارغًا لاستخدام صفحة العطلات الرسمية باللغة الإنجليزية.",
  "Edit holiday": "تعديل العطلة",
  "e.g. Eid al-Fitr": "مثال: عيد الفطر",
  "Counts as half a day off in leave calculations.": "يُحتسب نصف يوم عطلة في حساب الإجازات.",
  "Delete {name}?": "حذف {name}؟",
  "Remove {name}?": "إزالة {name}؟",
  "Remove": "إزالة",
  "Calendars that are or were assigned to employees are kept for history and can only be deactivated.": "التقاويم المخصَّصة للموظفين حاليًا أو سابقًا تُحفظ للسجل ويمكن تعطيلها فقط.",
  "Removing a holiday affects leave calculations for dates that have not been finalized.": "تؤثر إزالة العطلة في حساب الإجازات للتواريخ التي لم تُعتمد نهائيًا بعد.",
  "Linked to the official {link}": "مرتبط بـ{link} الرسمية",
  "government holiday page": "صفحة العطلات الحكومية",
  "Last checked {time} — {message}": "آخر فحص {time} — {message}",
  "Not checked yet.": "لم يُفحص بعد.",
  "Check official site": "فحص الموقع الرسمي",
  "Official holidays — {name}": "العطلات الرسمية — {name}",
  "Close": "إغلاق",
  "Apply {n} changes": "تطبيق {n} تغييرات",
  "Apply {n} change": "تطبيق {n} تغيير",
  "Reading the official page…": "جارٍ قراءة الصفحة الرسمية…",
  "Up to date — all {n} official dates for {year} are already in this calendar.": "محدَّث — جميع التواريخ الرسمية لعام {year} ({n}) موجودة بالفعل في هذا التقويم.",
  "The official {year} list differs from this calendar. Review the changes below, then apply. Holidays you added yourself are never changed.": "القائمة الرسمية لعام {year} تختلف عن هذا التقويم. راجع التغييرات أدناه ثم طبّقها. العطلات التي أضفتها بنفسك لا تتغير أبدًا.",
  "To add ({n})": "للإضافة ({n})",
  "To remove — no longer on the official list ({n})": "للإزالة — لم تعد في القائمة الرسمية ({n})",
  "Your own entries on the same dates are kept: {list}.": "يُحتفظ بإدخالاتك في التواريخ نفسها: {list}.",
  "Server can't reach the site? Paste the page text instead": "الخادم لا يستطيع الوصول إلى الموقع؟ الصق نص الصفحة بدلًا من ذلك",
  "Paste the official page": "لصق الصفحة الرسمية",
  "Open the official page in your browser, select all (Ctrl+A), copy (Ctrl+C) and paste here.": "افتح الصفحة الرسمية في متصفحك، وحدّد الكل (Ctrl+A)، وانسخ (Ctrl+C)، ثم الصق هنا.",
  "Read pasted text": "قراءة النص الملصق",
  "Error {status}": "خطأ {status}",
  "This tablet is not paired": "هذا الجهاز اللوحي غير مربوط",
  "An administrator can open {path}, create a “Door QR kiosk” and open its pairing link on this tablet.": "يمكن لمسؤول النظام فتح {path}، وإنشاء «جهاز الباب برمز QR»، ثم فتح رابط الربط الخاص به على هذا الجهاز اللوحي.",
  "Attendance → Devices": "الحضور ← الأجهزة",
  "Full screen": "ملء الشاشة",
  "Attendance QR code": "رمز QR للحضور",
  "Connecting…": "جارٍ الاتصال…",
  "Scan with your phone camera to clock in or out": "امسح الرمز بكاميرا هاتفك لتسجيل الحضور أو الانصراف",
  "Reconnecting…": "جارٍ إعادة الاتصال…",
  "code changes every 30 seconds": "يتغيّر الرمز كل 30 ثانية",
  "Today": "اليوم",
  "of {time} expected": "من {time} مطلوبة",
  "On leave today": "في إجازة اليوم",
  "No work scheduled today": "لا يوجد عمل مجدول اليوم",
  "Clocked in since {time}": "مسجَّل الحضور منذ {time}",
  "Clocked out at {time}": "سُجِّل الانصراف الساعة {time}",
  "Arrived {time} late": "وصل متأخرًا {time}",
  "Today's punches": "تسجيلات اليوم",
  "My attendance": "حضوري",
  "Your login is not linked to an employee record, so there is no personal attendance to show.": "حساب الدخول الخاص بك غير مرتبط بسجل موظف، لذا لا يوجد حضور شخصي لعرضه.",
  "Times shown in {zone} unless you change the time display at the top.": "تُعرض الأوقات بتوقيت {zone} ما لم تغيّر إعداد عرض الوقت في الأعلى.",
  "History": "السجل",
  "Something wrong? Ask your administrator to correct it — every correction is recorded with a reason.": "هل هناك خطأ؟ اطلب من مسؤول النظام تصحيحه — كل تصحيح يُسجَّل مع سببه.",
  "Reporting periods": "الفترات",
  "Closed": "مُقفلة",
  "Current": "الحالية",
  "Being finalised": "قيد الاعتماد النهائي",
  "Closed periods show the figures as they were finalised. Click a period to see its days.": "تعرض الفترات المُقفلة الأرقام كما اعتُمدت نهائيًا. انقر على فترة لعرض أيامها.",
  "Scan the office door code": "امسح رمز باب المكتب",
  "Open your phone camera and point it at the QR code on the office tablet.": "افتح كاميرا هاتفك ووجّهها نحو رمز QR على الجهاز اللوحي في المكتب.",
  "Clocked in at {time}": "سُجِّل الحضور الساعة {time}",
  "You were already clocked in, so nothing changed.": "كنت مسجَّل الحضور مسبقًا، لذا لم يتغير شيء.",
  "You had just scanned — the earlier scan was kept.": "لقد مسحت الرمز للتو — تم الاحتفاظ بالمسح السابق.",
  "Recorded by {device}.": "سُجِّل بواسطة {device}.",
  "View my attendance →": "عرض حضوري ←",
  "Office door": "باب المكتب",
  "You are currently clocked in.": "أنت مسجَّل الحضور حاليًا.",
  "You are not clocked in yet.": "لم تسجّل حضورك بعد.",
  "This code has expired. Scan the code on the tablet again.": "انتهت صلاحية هذا الرمز. امسح الرمز على الجهاز اللوحي مرة أخرى.",
  "Work schedules": "جداول العمل",
  "Working days and hours. Times are in each employee's own time zone.": "أيام وساعات العمل. الأوقات حسب المنطقة الزمنية لكل موظف.",
  "New schedule": "جدول جديد",
  "No schedules yet": "لا توجد جداول بعد",
  "Create at least one schedule before adding employees.": "أنشئ جدول عمل واحدًا على الأقل قبل إضافة الموظفين.",
  "{time} / week": "{time} / أسبوع",
  "{n} employee": "{n} موظف",
  "{n} employees": "{n} موظفين",
  "late grace {time}": "سماح التأخير {time}",
  "New work schedule": "جدول عمل جديد",
  "Edit work schedule": "تعديل جدول العمل",
  "Save schedule": "حفظ الجدول",
  "This schedule is used by {n} employee(s). Edits apply to them going forward. To change hours only from a certain date, create a new schedule and schedule a work-terms change on each employee instead.": "يستخدم هذا الجدول {n} موظف/موظفين. تسري التعديلات عليهم من الآن فصاعدًا. لتغيير الساعات اعتبارًا من تاريخ معيّن فقط، أنشئ جدولًا جديدًا وجدوِل تغييرًا في شروط العمل لكل موظف بدلًا من ذلك.",
  "e.g. Sun–Thu 08:00–16:00": "مثال: الأحد–الخميس 08:00–16:00",
  "Daily worked-time rule": "قاعدة احتساب ساعات العمل اليومية",
  "Leave on company default unless this schedule needs its own rule.": "اتركه على إعداد الشركة الافتراضي ما لم يحتج هذا الجدول إلى قاعدة خاصة.",
  "Company default": "إعداد الشركة الافتراضي",
  "First sign-in → last sign-out": "من أول تسجيل حضور إلى آخر تسجيل انصراف",
  "Sum of all worked intervals": "مجموع كل فترات العمل",
  "Late arrival grace (minutes)": "سماح التأخر في الحضور (بالدقائق)",
  "Early departure grace (minutes)": "سماح الانصراف المبكر (بالدقائق)",
  "Working days": "أيام العمل",
  "Start": "البداية",
  "End": "النهاية",
  "break": "استراحة",
  "Break minutes": "دقائق الاستراحة",
  "min": "دقيقة",
  "An end time earlier than the start time means an overnight shift.": "وقت نهاية أبكر من وقت البداية يعني وردية ليلية.",
  "Schedules that are or were used by any employee are kept for history and can only be deactivated.": "الجداول التي يستخدمها أو استخدمها أي موظف تُحفظ للسجل ويمكن تعطيلها فقط.",
  "Filter… e.g. Beirut": "تصفية… مثال: Beirut",
  "Filter time zones": "تصفية المناطق الزمنية",
  "Select time zone…": "اختر المنطقة الزمنية…",
  // Also used in other areas (same wording as the shared dictionaries).
  "By employee": "حسب الموظف",
  "Attendance": "الحضور",
  "Date": "التاريخ",
  "Previous day": "اليوم السابق",
  "Next day": "اليوم التالي",
  "Department": "القسم",
  "All departments": "كل الأقسام",
  "Present": "حاضر",
  "Absent": "غائب",
  "Missing punch": "تسجيل ناقص",
  "No employees": "لا يوجد موظفون",
  "Employee": "موظف",
  "Choose an employee…": "اختر موظفًا…",
  "Period": "الفترة",
  "From": "من",
  "To": "إلى",
  "Export": "تصدير",
  "Choose an employee": "اختر موظفًا",
  "Cancel": "إلغاء",
  "Time": "الوقت",
  "Type": "النوع",
  "Reason": "السبب",
  "Recorded in the audit log.": "يُسجَّل في سجل التدقيق.",
  "Copied": "تم النسخ",
  "Copy": "نسخ",
  "Server address:": "عنوان الخادم:",
  "Disabled": "معطَّل",
  "Edit": "تعديل",
  "Time zone": "المنطقة الزمنية",
  "Last contact": "آخر اتصال",
  "Never": "أبدًا",
  "Done": "تم",
  "Edit {name}": "تعديل {name}",
  "Save": "حفظ",
  "Name": "الاسم",
  "Active": "نشط",
  "Worked": "ساعات العمل",
  "Status": "الحالة",
  "Reporting period closed": "الفترة مُقفلة",
  "Inactive": "غير نشط",
  "Year": "السنة",
  "Delete": "حذف",
  "Country": "الدولة",
  "Leave": "الإجازات",
  "Description": "الوصف",
  "Day off": "يوم عطلة",
};
